import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";
import exportedEvents from "./exportCalendar";
import AppContext from "../appContext";

import * as api from "../services";

function useSaveMutation({ events = [], onSuccess = () => false }) {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      path,
      sessionId,
    },
  } = useContext(AppContext);
  const history = useHistory();
  const unlockMutation = useMutation(() =>
    api.requestUnlock({ clientId, sessionId })
  );
  const saveMutation = useMutation(
    () => {
      const beepSchedule = exportedEvents(events);
      return api.postBeepSchedule({
        clientId,
        beepSchedule,
        projectId,
        sessionId,
      });
    },
    {
      onSuccess: (data) => {
        if (data.data?.status === 1) {
          onSuccess(data.data);
          unlockMutation.mutate(); // unlock client
          history.push({
            pathname: path, // go back to client page
            state: {
              from: "editor",
            },
          });
        }
      },
    }
  );

  return saveMutation;
}

export default useSaveMutation;
